import { SourcingItem } from '@innowise-group/core';

export const sourcingFormDefaultValues: SourcingItem = {
  employeeId: '',
  requiredNumberOfEvents: '30',
};
